import React from 'react'
import { Card } from 'react-bootstrap'
// import Rating from './Rating'
import { Link } from 'react-router-dom'
import { BASE_URL } from '../constants/urlConstants'

function Product({product}) {
  return (
    <div>
      <Card className='p-3 my-3 rounded '>
         <Link to={`/product/${product._id}`}>
            <Card.Img src={`${BASE_URL}/${product.image}`} className='card-img-top'/>
        </Link>
        <Card.Body>
        <Link to={`/product/${product._id}`} className='no_underline'>
            <Card.Title as="div">
                <p className='large'>{product.name}</p>
            </Card.Title>
        </Link>
        {/* <Card.Text as="h3">
                {product.price} ریال
            </Card.Text> */}
            {/* <Card.Text as="div" className='my-3'>
               
                <Rating value={product.rating} text={`${product.numReviews} reviews`} color={"#aaf542"}/>

            </Card.Text>

            <Card.Text as="h3">
                ${product.price}
            </Card.Text> */}
        </Card.Body>

      </Card>
    </div>
  )
}

export default Product
